import styled from "@emotion/styled";

type AlignItemsType = "center" | "flex-end" | "flex-start";
type JustifyContentType =
  | "center"
  | "flex-end"
  | "flex-start"
  | "space-between"
  | "space-around";

export const StyledFlex = styled("div")<{
  $alignItems?: AlignItemsType;
  $justifyContent?: JustifyContentType;
  $mdFlexFlow?: "row" | "column";
  $gap?: number;
  $fullHeight?: boolean;
  $flexDirection?: "column" | "row";
  $flexWrap?: "wrap" | "nowrap";
  $overflow?: "hidden" | "auto" | "scroll";
  $flexGrow?: number;
  $marginTop?: number;
  $marginBottom?: number;
}>`
  display: flex;
  max-width: 100%;
  flex-direction: ${(props) =>
    props.$flexDirection ? props.$flexDirection : ""};
  flex-wrap: ${(props) => (props.$flexWrap ? props.$flexWrap : "")};
  align-items: ${(props) => (props.$alignItems ? props.$alignItems : "")};
  justify-content: ${(props) =>
    props.$justifyContent ? props.$justifyContent : ""};
  gap: ${(props) => (props.$gap ? props.theme.spacing(props.$gap) : "")};
  overflow: ${(props) => (props.$overflow ? props.$overflow : "")};
  margin-top: ${(props) =>
    props.$marginTop ? props.theme.spacing(props.$marginTop) : ""};
  margin-bottom: ${(props) =>
    props.$marginBottom ? props.theme.spacing(props.$marginBottom) : ""};

  ${(props) => props.theme.breakpoints.down("lg")} {
    flex-flow: ${(props) => (props.$mdFlexFlow ? props.$mdFlexFlow : "")};
  }

  ${(props) => props.$flexGrow && `flex-grow: ${props.$flexGrow};`}
  ${(props) =>
    props.$fullHeight &&
    `
      height: 100%;
    `}

    .flex-1 {
    flex: 1;
  }
`;

export const StyledInputLabel = styled.label<{ $hasError?: boolean }>`
  display: flex;
  align-items: center;
  color: ${(props) =>
    props.$hasError
      ? props.theme.colors.red
      : props.theme.palette.text.primary};
  margin-bottom: ${(props) => props.theme.spacing(0.5)};
  z-index: 1;
`;
